<template>
	<div>
		<slot/>
	</div>
</template>
<script>

import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import { Style, Fill, Stroke } from 'ol/style'
import GeoJSON from 'ol/format/GeoJSON.js'

import compiler from '../mixins/compilers/_compiler.js'

import { interval as intervalObs } from 'rxjs'
import { first as firstObs, map as mapObs, skipWhile, toPromise } from 'rxjs/operators'

const methods	= {
	createOlObject () {
		return new VectorLayer({
			zIndex: 100,
			visible: true,
			style: this.selectedStyle(),
			source: new VectorSource({

			})
		})
	},
	firstInit () {
      return intervalObs(100)
        .pipe(skipWhile(() => !this.$map))
        .pipe(skipWhile(() => !this.$view))
        .pipe(skipWhile(() => !this.$services.layersContainer))
        .pipe(firstObs())
        .pipe(mapObs(() => this))
        .toPromise(Promise)
    },
  callClickEvents (e) {
    this.clearSelected()
    this.$emit("clearSelected")
    let queryLayers = this.$layers.filter((layer) => layer.selectable && layer.$layer.getVisible()).map((layer) => {
      return [layer.$vueSource.getFeaturesAtCoordinate(e.coordinate),layer.infoSettings,layer.legendName]
    });
    var vm = this;
    queryLayers.forEach((queryLayer) => {
      axios.get(queryLayer[0])
      .then(({data}) => this.parseSelected(data,queryLayer[1],queryLayer[2]))
      .catch(function (error) {
          // handle error
          console.log(error);
        })
    })
  },
  highlightSelected(e){
  	let matched = this.$selectableLayer.getSource().getFeatures().filter((feature) => feature.getId() == e.feature.id)
  	if(e.highlight){
  		matched[0].setStyle(this.highlightStyle)
  	} else {
  		matched[0].setStyle(null)
  	}
  },
  // highlightStyle(){
  // 	let style = new Style({
  // 		fill: new Fill({color: 'rgba(255,255,0,0.8)'}),
  // 		stroke: new Stroke({ color: '#ff0', width: 2 }),
  // 		zIndex: 100
  // 	})
  // 	return style
  // },
  selectedStyle(){
  	let style = new Style({
  		fill: new Fill({color: 'rgba(0,255,255,0.7)'}),
  		stroke: new Stroke({ color: '#0ff', width: 2 })
  	})
  	return style
  },
  parseSelected (data,infoSettings,layerName) {
    var vm = this
    let rawFeatures = data["features"].map((feature) => {
      feature["infoSettings"] = infoSettings
      feature["layer"] = layerName
      return feature  
    })
    this.selected.push(...rawFeatures);
    this.$emit("featureSelected",rawFeatures)
    let features = data["features"].map((feature) => {
    	let readFeature = vm.$geojson.readFeature(feature)
    	vm.$selectableLayer.getSource().addFeature(readFeature)
    	return readFeature
    })
    this.features.push(...features)
  },
  clearSelected (){
    this.selected=[]
    this.$selectableLayer.getSource().clear()
  },
	mount() {

	}
}

export default {

  name: 'selectable-layer',
  mixins: [compiler],
  methods,
  data () {
    return {
    	selected:[],
    	features:[],
    	highlightStyle: new Style({
	  		fill: new Fill({color: 'rgba(255,255,0,0.8)'}),
	  		stroke: new Stroke({ color: '#ff0', width: 2 }),
	  		zIndex: 100
  		})
    }
  },
  created() {
  	this.$selectableLayer = undefined
  	this.$geojson = undefined
  	Object.defineProperties(this, /** @lends module:map/view# */{
  	  /**
  	   * @type {ol.Layer|undefined}
  	   */
  	  $selectableLayer: {
  	    enumerable: true,
  	    get: () => this.$olObject,
  	  },
  	  $map: {
  	    enumerable: true,
  	    get: () => this.$parent.$map,
  	  },
  	  $view: {
  	    enumerable: true,
  	    get: () => this.$parent.$view,
  	  },
      $layers: {
        enumerable: true,
        get: () => this.$services.layersContainer.getVueLayers(),
      },
  	  // $legendContainer: {
  	  //   enumerable: true,
  	  //   get: () => this._legendContainer
  	  // }
  	})
  	this.firstInit().then(() => {
  		this.$map.addLayer(this.$olObject);
  		this.$geojson = new GeoJSON({
  			dataProjection:this.$view.getProjection(),
  			featureProjection:this.$view.getProjection()
  		})
  		this.$parent.$on("click",(e)=>{this.callClickEvents(e)})
  		this.$on("resetFeatures",(e)=>{this.clearSelected()})
  		this.$on("highlightFeature",(e)=>{this.highlightSelected(e)})
  	})
  }
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// resources/js/map/MapComponents/Layers/SelectableLayer.vue